import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';

import './ProgressIndicator.scss';

class ProgressIndicator extends BaseComponent {

  componentDidMount() {
    this.animateProgress();
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  animateProgress() {
    let width = 0;
    const self = this;
    this.interval = setInterval(() => {
      if (self.progressElement && self.loadingElement) {
        let parentRect = self.loadingElement.getBoundingClientRect();

        width++;
        if (width >= parentRect.width) {
          width = 0;
        }
        self.setState({ progressWidth: width });
      }
    }, 20);
  }

  render() {
    const { 
      width, 
      height, 
      marginLeft, 
      marginRight, 
    } = this.props;

    let containerStyle = {
      marginLeft,
      marginRight,
    };

    const progressStyle = this.state.progressWidth
    ? { 
      width: this.state.progressWidth ,
      height: height,
    }
    : {
      height: height,
    };

    return (
        <div className='progress-indicator-container' style={containerStyle}>
        <div 
          className="loading-indicator" 
          id={'loading-indicator'} 
          ref={element => {
            this.loadingElement = element;
          }}
          style={{ width: width, height: height }}
          >
            <div 
              className="progress-indicator" 
              id={'progress-indicator'} 
              ref={element => {
                this.progressElement = element;
              }} 
              style={progressStyle}/>
        </div>
      </div>
    );
  }
}

export default ProgressIndicator;



// WEBPACK FOOTER //
// ./src/components/ProgressIndicator/index.js